// extracted by mini-css-extract-plugin
export default {"head":"Home_head__jkbQH","Home":"Home_Home__oT4zE","about":"Home_about__MX2Of"};